const env = process.env.REACT_APP_DEPLOY_ENV;

export const CONNECTIVITY_ERROR = "connectivity";
export const EXPIREDCOOKIE_ERROR = "No valid session cookie!";   // same as in the graph api implementation
export const NEWER_VERSION_ERROR = "Newer version exists";
export const TOPIC_NEWER_VERSION_ERROR = "Topic has been modified";
export const INVALID_SESSION_STATUS_CODE = 401;
export const STRIPE_PUBLIC_KEY = env === "production" ? "pk_live_WP7tWj9Fwq7UtuxE9lGV64Hg" : "pk_test_OTiVCeCxAZjtkvoAG2kZ102S00hXMZ3ztu";
